import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/rules-of-hooks */
import { Components as ListComponents } from './typeaheadList.style';
import { forwardRef } from 'react';
import Icon from '../Icon';
import { markMatch, normalizeInput } from './typeahead.util';
const renderSuggestionPrimary = function () {
  let primary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let idx = arguments.length > 1 ? arguments[1] : undefined;
  let markinput = arguments.length > 2 ? arguments[2] : undefined;
  let inputText = arguments.length > 3 ? arguments[3] : undefined;
  if (!markinput) {
    return primary;
  }
  const value = normalizeInput(inputText || '');
  const matches = _toConsumableArray(new Set(primary.match(new RegExp(value, 'gi'))));
  return markMatch(primary, matches, idx);
};
const renderSuggestionSecondary = function () {
  let secondary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let idx = arguments.length > 1 ? arguments[1] : undefined;
  return secondary ? _jsx("span", {
    children: secondary
  }, idx) : '';
};
const renderSuggestionIcon = (icon, idx) => {
  return icon ? _jsx(ListComponents.Icon, {
    children: _jsx(Icon, {
      name: icon
    })
  }, idx) : '';
};
export const TypeaheadOptions = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    options = [],
    onSuggestionClick,
    grouped,
    inputText,
    hoveredVal = '',
    defaulHighLighttValue,
    noresult,
    disabled,
    markinput
    // tooltipDescription,
  } = props;
  //LI wrapper of typeahead
  return options === null || options === void 0 ? void 0 : options.map((option, idx) => {
    var _a, _b;
    const arrayTocheck = hoveredVal ? [inputText, hoveredVal] : [inputText, defaulHighLighttValue];
    const isActive = arrayTocheck.map(m => m === null || m === void 0 ? void 0 : m.trim().toLocaleLowerCase()).includes((_b = (_a = option === null || option === void 0 ? void 0 : option.value) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase());
    return (option === null || option === void 0 ? void 0 : option.error) ? _jsx(ListComponents.Item, _extends({
      disabled: option.text === noresult,
      active: !!noresult && option.text === noresult,
      ref: ref
    }, {
      children: renderSuggestionPrimary(option === null || option === void 0 ? void 0 : option.text, idx, !!markinput, inputText)
    }), idx) : _jsxs(ListComponents.Item, _extends({
      ref: ref,
      disabled: disabled || (option === null || option === void 0 ? void 0 : option.disabled),
      indented: grouped,
      onClick: () => disabled || (option === null || option === void 0 ? void 0 : option.disabled) ? false : onSuggestionClick === null || onSuggestionClick === void 0 ? void 0 : onSuggestionClick(option),
      active: isActive,
      className: "".concat(isActive ? 'active' : '')
    }, {
      children: [renderSuggestionIcon(option === null || option === void 0 ? void 0 : option.icon, idx), _jsxs(ListComponents.Content, _extends({
        active: isActive,
        className: "".concat(isActive ? 'active' : ''),
        markInput: markinput
      }, {
        children: [renderSuggestionPrimary(option.value, idx, !!markinput, inputText), renderSuggestionSecondary(option === null || option === void 0 ? void 0 : option.secondary, idx)]
      }))]
    }), idx);
  });
});